@if (!customFindbarInputArea) {
  <div id="findbarInputContainer">
    <pdf-search-input-field></pdf-search-input-field>
    <pdf-find-previous></pdf-find-previous>
    <pdf-find-next></pdf-find-next>
  </div>
}

<ng-container [ngTemplateOutlet]="customFindbarInputArea || null"> </ng-container>
